import { Paper } from "@mui/material";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import moment from "moment";
import { formatDecimal } from "../utils/common";
import { NormalizedPowerRow } from "../types/power";

const columns: GridColDef<NormalizedPowerRow>[] = [
  {
    field: "name",
    headerName: "Room",
    flex: 1,
    minWidth: 140,
  },
  {
    field: "model",
    headerName: "Model",
    width: 120,
  },
  {
    field: "voltage",
    headerName: "Voltage",
    width: 120,
    valueGetter: (params: GridValueGetterParams<NormalizedPowerRow>) =>
      `${formatDecimal(params.row.voltage ?? 0) || 0} V`,
  },
  {
    field: "current",
    headerName: "Current",
    width: 120,
    valueGetter: (params: GridValueGetterParams<NormalizedPowerRow>) =>
      `${formatDecimal(params.row.current ?? 0) || 0} A`,
  },
  {
    field: "power_active",
    headerName: "Power Active",
    width: 140,
    valueGetter: (params: GridValueGetterParams<NormalizedPowerRow>) =>
      `${formatDecimal(params.row.power_active ?? 0, 1) || 0} W`,
  },
  {
    field: "export_energy_active",
    headerName: "Export Energy",
    width: 150,
    valueGetter: (params: GridValueGetterParams<NormalizedPowerRow>) =>
      `${formatDecimal(params.row.export_energy_active ?? 0) || 0} kWh`,
  },
  {
    field: "created_at",
    headerName: "Date",
    width: 130,
    valueGetter: (params: GridValueGetterParams<NormalizedPowerRow>) =>
      `${moment(params.row.created_at).format("MMM D, YYYY")}`,
  },
  {
    field: "created_time",
    headerName: "Time",
    width: 120,
    valueGetter: (params: GridValueGetterParams<NormalizedPowerRow>) =>
      `${moment(params.row.created_at).format("h:mm A")}`,
  },
];

interface PowerTableProps {
  rows: NormalizedPowerRow[];
  loading?: boolean;
}

const PowerTable = ({ rows, loading }: PowerTableProps) => (
  <Paper
    sx={{
      p: { xs: 2, md: 3 },
      borderRadius: 4,
      border: "1px solid rgba(13, 27, 42, 0.06)",
      background: "rgba(255, 255, 255, 0.95)",
    }}
  >
    <DataGrid
      autoHeight
      rows={rows}
      columns={columns}
      loading={loading}
      pageSize={10}
      rowsPerPageOptions={[10, 25, 50]}
      disableSelectionOnClick
    />
  </Paper>
);

export default PowerTable;
